export const matchesSearch = (employee, searchName, excludedEmail = null) => {
    if (!searchName?.trim()) return true;
    if (!searchName || employee.email === excludedEmail) return false;

    const searchLower = searchName.toLowerCase();
    const fieldsToSearch = [
        employee.firstname,
        employee.middlename,
        employee.lastname,
        employee.email
    ];

    return fieldsToSearch.some((field) =>
        field?.toLowerCase().includes(searchLower)
    );
};
export const isDescendant = (empTree, employeeEmail, potentialManagerEmail) => {
    const dfs = (node) => {
        if (!node || !node.subordinates) return false;
        for (let sub of node.subordinates) {
            if (sub.userId === potentialManagerEmail) return true;
            if (dfs(sub)) return true;
        }
        return false;
    };

    // Find the node of the current employee
    const findEmployeeNode = (tree) => {
        for (let node of tree) {
            if (node.userId === employeeEmail) return node;
            const child = findEmployeeNode(node.subordinates || []);
            if (child) return child;
        }
        return null;
    };

    const employeeNode = findEmployeeNode(empTree);
    if (!employeeNode) return false;

    return dfs(employeeNode);
};
export const isAncestor = (tree, potentialSubordinateEmail, selectedEmployeeEmail) => {
    const dfs = (node) => {
        if (!node || !node.subordinates) return false;
        for (let sub of node.subordinates) {
            if (sub.userId === selectedEmployeeEmail) return true;
            if (dfs(sub)) return true;
        }
        return false;
    };

    const findNode = (tree) => {
        for (let node of tree) {
            if (node.userId === potentialSubordinateEmail) return node;
            const found = findNode(node.subordinates || []);
            if (found) return found;
        }
        return null;
    };

    const potentialSubNode = findNode(tree);
    if (!potentialSubNode) return false;

    return dfs(potentialSubNode);
};
